<template>
  <div class="navbar">
    <div class="left-panel">
      <i
        :class="sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
        class="hamburger"
        @click="toggleSidebar"
      />
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path">
          <span v-if="index === breadcrumbs.length - 1">{{ item.meta.title }}</span>
          <router-link v-else :to="item.path">{{ item.meta.title }}</router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right-panel">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-dropdown">
          <el-avatar :size="32" icon="el-icon-user-solid" />
          <span class="username">{{ userInfo.nickname || userInfo.username || '管理员' }}</span>
          <i class="el-icon-arrow-down" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    breadcrumbs() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      return matched
    }
  },
  methods: {
    toggleSidebar() {
      this.$store.dispatch('app/toggleSidebar')
    },
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确定退出登录吗？', '提示', { type: 'warning' }).then(() => {
          this.$store.dispatch('user/logout').then(() => {
            this.$router.push('/login')
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: $navbar-height;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.left-panel {
  display: flex;
  align-items: center;

  .hamburger {
    font-size: 20px;
    cursor: pointer;
    margin-right: 16px;
    color: #4e5969;
    &:hover { color: $primary; }
  }
}

.right-panel {
  .user-dropdown {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #4e5969;

    .username {
      margin: 0 8px;
      font-size: 14px;
    }
  }
}
</style>
